import { Badge } from "@hortis/ui/badge";
import { Dot } from "@hortis/ui/dot";
import { PlantMaterialStatus } from "generated/graphql";
import { HTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

function countAndSortStatuses(data: Array<{ status: PlantMaterialStatus }>) {
  const counts: Record<PlantMaterialStatus, number> = {
    [PlantMaterialStatus.Present]: 0,
    [PlantMaterialStatus.Transient]: 0,
    [PlantMaterialStatus.Unknown]: 0,
    [PlantMaterialStatus.Absent]: 0,
  };

  for (const item of data) {
    counts[item.status] += 1;
  }

  return counts;
}

export const AccessionMaterialStatusSummary = ({
  className,
  materials,
  ...props
}: HTMLAttributes<HTMLDivElement> & {
  materials: Array<{ status: PlantMaterialStatus }>;
}) => {
  const statusCounts = countAndSortStatuses(materials);
  return (
    <div
      className={twMerge("flex gap-0.5 items-center flex-wrap", className)}
      {...props}
    >
      {materials.length === 0 ? (
        <Badge
          variant="soft"
          color="grey"
          className="[&_span]:gap-1.5 border border-grey-200 bg-white mix-blend-normal"
        >
          No material
        </Badge>
      ) : (
        <>
          {statusCounts.PRESENT > 0 && (
            <Badge
              variant="soft"
              color="grey"
              className="[&_span]:gap-1.5 border border-grey-200 bg-white mix-blend-normal"
            >
              <Dot color="primary" />
              {statusCounts.PRESENT}
            </Badge>
          )}
          {statusCounts.TRANSIENT > 0 && (
            <Badge
              variant="soft"
              color="grey"
              className="[&_span]:gap-1.5  border border-grey-200 bg-white mix-blend-normal"
            >
              <Dot color="warning" />
              {statusCounts.TRANSIENT}
            </Badge>
          )}
          {statusCounts.UNKNOWN > 0 && (
            <Badge
              variant="soft"
              color="grey"
              className="[&_span]:gap-1.5  border border-grey-200 bg-white mix-blend-normal"
            >
              <Dot color="error" />
              {statusCounts.UNKNOWN}
            </Badge>
          )}
          {statusCounts.ABSENT > 0 && (
            <Badge
              variant="soft"
              color="grey"
              className="[&_span]:gap-1.5  border border-grey-200 bg-white mix-blend-normal"
            >
              <Dot color="grey" />
              {statusCounts.ABSENT}
            </Badge>
          )}
        </>
      )}
    </div>
  );
};
